import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  // useLayoutEffect runs before the browser paints, so we can set
  // the scroll position immediately and avoid any visible jump/animation.
  useLayoutEffect(() => {
    try {
      // instant jump to top (no smooth) so user doesn't see movement
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0);
    } catch (e) {
      // ignore if environment doesn't support
    }
  }, [pathname]);

  return null;
}
